import { spacing } from "@layout";
import { CSSProperties } from "react";

export const styles: Record<string, CSSProperties> = {
  amount: {
    fontWeight: "bold",
    fontSize: 30,
  },
  container: {
    width: "100%",
    paddingRight: spacing.s,
    flexDirection: "row",
    justifyContent: "space-between",
  },
  change: {
    fontWeight: 700,
  },
};
